const Colors = {
    BLACK: 'black',
 


};

export default Colors;